import React from 'react';
import PropTypes from 'prop-types';
import grayLogo from '../../../../assets/images/Logo_Gray.svg';
function ConsultantReferralsReceived(_ref) {
  var notOne = _ref.notOne,
    referralsPath = _ref.referralsPath;
  var plural = notOne ? 's' : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-style style-guide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center title"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: grayLogo,
    alt: "",
    height: "38",
    width: "90"
  })), /*#__PURE__*/React.createElement("h1", {
    className: "modal-header"
  }, "Clora has received your referral", plural, "!"), /*#__PURE__*/React.createElement("div", {
    className: "subtext mx-2 mx-md-5"
  }, "Thanks for spreading the word and helping more consultants find the right opportunities."), /*#__PURE__*/React.createElement("div", {
    className: "form-wrapper mb-0 mx-2 mx-md-5"
  }, /*#__PURE__*/React.createElement("a", {
    href: referralsPath,
    className: "btn btn-primary",
    id: "consultant-track-recommendations"
  }, "Track my referrals"))));
}
ConsultantReferralsReceived.propTypes = {
  referralsPath: PropTypes.string.isRequired,
  notOne: PropTypes.bool
};
ConsultantReferralsReceived.defaultProps = {
  notOne: true
};
export default ConsultantReferralsReceived;